import { useQuoteParams } from '@/features/quotes/context/quote-params.context';
import { commissionLimitsService } from '@/services/commission-limits';
import type { CommissionLimits } from '@/services/commission-limits/types';
import { useQuery } from '@tanstack/react-query';

const VERSION_DATE = '2025-11-03';

const FALLBACK_LIMITS: CommissionLimits = {
  minCommission: 1,
  maxCommission: 40,
};

export function useCommissionLimits() {
  const { productCode } = useQuoteParams();

  return useQuery({
    queryKey: ['commission-limits', productCode],
    enabled: Boolean(productCode),
    staleTime: 1000 * 60 * 10,
    queryFn: async (): Promise<CommissionLimits> => {
      const result = await commissionLimitsService.getCommissionLimits(
        productCode,
        VERSION_DATE
      );

      if (!result.success || !result.data) {
        return FALLBACK_LIMITS;
      }

      const { minCommission, maxCommission } = result.data;
      if (minCommission === 0 && maxCommission === 100) {
        return FALLBACK_LIMITS;
      }

      return result.data;
    },
  });
}
